import { createContext, useContext } from 'react';
import { useScreenSidebar } from './useSidebar';
const Context = createContext({
    id: 'default',
});
export const useScreenLayout = () => {
    const { id } = useContext(Context);
    const sidebar = useScreenSidebar(id);
    return {
        id,
        sidebar,
    };
};
export function ScreenLayoutProvider(props) {
    const { id, children } = props;
    const value = {
        id,
    };
    return <Context.Provider value={value}>{children}</Context.Provider>;
}
